import { render, staticRenderFns } from "./maintainanceTaskDetailsList.vue?vue&type=template&id=424a8a54&scoped=true"
import script from "./maintainanceTaskDetailsList.vue?vue&type=script&lang=js"
export * from "./maintainanceTaskDetailsList.vue?vue&type=script&lang=js"
import style0 from "./maintainanceTaskDetailsList.vue?vue&type=style&index=0&id=424a8a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a8a54",
  null
  
)

export default component.exports